import axios from "axios";

// Prefer the build-time backend URL, but fall back to the page's own origin
// at runtime so the app keeps working regardless of which domain it's served
// from (custom domain, emergent.host, preview URL, etc.).
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RUNTIME_BACKEND_URL =
  typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = ENV_BACKEND_URL || RUNTIME_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
